/* eslint-disable react/no-danger */
import React from 'react';
import { ViewWrapper, SinglePageWrapper, MDXContentWrapper } from '@/styles/index';
import Navbar from '@/components/Layout/Navbar';
// import Footer from '@/components/Layout/Footer';
import BaseCTA from '@/components/Layout/CTA';
import hydrate from 'next-mdx-remote/hydrate';
import HeadMeta from '@/components/HeadMeta';
import { useSession } from 'next-auth/client';
import { getFileBySlug } from '@/lib/mdx';
// import BlogLayout from '@/components/Layout/Blog';
import MDXComponents from '@/components/MDXComponents';
import dynamic from 'next/dynamic';
import siteConfig from '../siteConfig';

const Footer = dynamic(() => import('@/components/Layout/Footer'));

const Privacy = ({ mdxSource, frontMatter }) => {
  const [session] = useSession();
  const content = hydrate(mdxSource, {
    components: MDXComponents
  });
  // console.log({ frontMatter });
  const contentSchema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: frontMatter.title,
    // wordCount: frontMatter.wordCount,
    name: frontMatter.title,
    datePublished: frontMatter.publishedAt, // '2015-02-05T08:00:00+08:00',
    dateModified: frontMatter.modifiedAt || frontMatter.publishedAt, // '2015-02-05T09:20:00+08:00',
    image: siteConfig.siteBanner,
    author: {
      '@type': 'Organization',
      url: siteConfig.siteUrl,
      logo: siteConfig.siteFav,
      email: siteConfig.userEmail,
      name: siteConfig.siteTitleAlt
    },
    publisher: {
      '@type': 'Organization',
      name: siteConfig.siteTitleAlt,
      logo: {
        '@type': 'ImageObject',
        url: siteConfig.siteFav
      }
    }
  };
  return (
    <ViewWrapper>
      <HeadMeta title={`${frontMatter.title} – Pollme`}>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(contentSchema) }}
        />
      </HeadMeta>
      <Navbar session={session} />
      <SinglePageWrapper>
        <MDXContentWrapper>
          <h1>{frontMatter.title}</h1>
          {content}
        </MDXContentWrapper>
      </SinglePageWrapper>
      <BaseCTA />
      <Footer />
    </ViewWrapper>
  );
};

export default Privacy;

export async function getStaticProps({ locale, defaultLocale }) {
  const uses = await getFileBySlug('privacy', null, { locale, defaultLocale });

  return { props: uses };
}
